import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollTimeSheetSetup } from "../../components/PayrollTimeSheetSetup";

export const PayrollTimeSheetSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Payroll", navigateTo: "/taxes/remittance/cra" },
      ]}
      mainContents={<PayrollTimeSheetSetup />}
    />
  );
};
